import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareTimelineEmbedRoute: InvariantJiraRoute = {
	name: 'software-timeline-embed',
	path: '/jira/software/projects/:projectKey/boards/:boardId/timeline/embed',
};
